const productAppSection = $('#app-section');
const productAppSectionTopper = productAppSection.find('.section-topper');
const cardsOverflow = productAppSection.find('.app-card-list-overflow');
const cards = productAppSection.find('.app-card-parent');

const lottieCenterFrames = [110, 110, 204, 60, 110, 60];
const cardLotties = [];

const addCardsScroll = () => {
  const scrollTL = gsap.timeline({ paused: true });

  scrollTL.add(
    gsap.fromTo(
      cards,
      { x: 0 },
      {
        x: `-${66.6 - 1.875 - 0.625 * 1}vw`,
        duration: 1,
        ease: CustomEase.create('custom', '0.17, 0, 0.2, 1'),
        stagger: { each: 0.1 },
      }
    )
  );

  return scrollTL;
};

const addAppAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const appCards = productAppSection.find('.app-card-parent');

  const appTopperTL = gsap.timeline({
    paused: true,
  });
  const appTL = gsap.timeline({
    paused: true,
  });

  if (isDesktop()) {
    appTopperTL.add(
      animateSectionTopperIn({
        sectionParent: productAppSection,
        gradientConfig: gradientConfig,
      }).play(),
      0
    );
  }

  appTL.add(
    gsap.fromTo(
      appCards,
      { x: '100vw' },
      {
        x: 0,
        duration: 1,
        stagger: { each: 0.1 },
        ease: 'inEasing',
      }
    ),
    0.4
  );

  return [appTopperTL, appTL];
};

let appTopperST, appST;
let appTopperTL, appTL;

function initAppScrollTriggers() {
  if (appTopperST) appTopperST.kill();
  if (appST) appST.kill();

  [appTopperTL, appTL] = isDesktop() ? addAppAnimation() : [false, false];

  if(isDesktop()){
    appTopperST = ScrollTrigger.create({
      trigger: productAppSectionTopper,
      start: 'top top+=120%',
      end: 'top top+=40%',
      once: true,
      onUpdate: (self) => {
        appTopperTL.progress(self.progress);
      },
    });

    appST = ScrollTrigger.create({
      trigger: productAppSectionTopper,
      start: 'top top+=120%',
      end: 'top top',
      once: true,
      onEnter: (self) => {
        appTL.play();
      },
    });
  } else {
    gsap.set(cardsOverflow, { overflowX: 'scroll' });
  }

}

const initProductsAppEmbla = () => {
    const embla = productAppSection.find('.embla');
    const viewport = embla.find('.embla__viewport');
    if (!window.EmblaCarousel || !viewport.length) {
      return;
    }
    const prevBtn = embla.find('.embla__button--prev')
    const nextBtn = embla.find('.embla__button--next');
    const OPTIONS = { align: 'start', dragFree: true };
    const emblaApi = EmblaCarousel(viewport.get(0), OPTIONS);
    const slides = embla.find('.embla__slide')

    initEmblaControls(emblaApi, prevBtn, nextBtn)
};

const initProductsApp = () => {
  initProductsAppEmbla();
  initAppScrollTriggers();
  $(window).on('deviceChange', initAppScrollTriggers);
}

/*
$(window).on('load', () => {
  initProductsApp();
});
*/

addSectionObserver(productAppSection, initProductsApp);
